module.exports = __webpack_public_path__ + "img/interactive-icon.ba34bd0b.svg";